var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"RBIj73KaQFg8rZuuC8MEo"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs"

const ENV = process.env.NEXT_PUBLIC_ENV || "dev"
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
  dsn:
    SENTRY_DSN ||
    "https://ecbc3588792b4b899f3331886a4dfbef@o1048015.ingest.sentry.io/6459940",
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: ENV === "prod" ? 0.1 : 0,
  // SDK v7 기본값 ['localhost', /^\/(?!\/)/] 은 localhost 요청에도 sentry-trace/baggage를
  // 붙여, 키오스크 로컬 서버(locker.exe, localhost:2024) 통신에서 CORS 프리플라이트를 유발한다.
  // 같은 오리진(상대경로)만 전파하도록 제한한다(v8 기본값과 동일).
  tracePropagationTargets: [/^\//],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  ignoreErrors: [
    "Non-Error exception captured",
    "Non-Error promise rejection captured",
  ],
})
